import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { App } from '@capacitor/app';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class CooldownService {

  private timer: any;
  public remainingSeconds: number = 0;

  constructor(private storage: Storage, private platform: Platform) {
    this.init();
  }

  private async init() {
    await this.storage.create();
    await this.loadCooldown();
    this.setupListeners();
  }

  /** ---------------------------
   *  Iniciar un nuevo cooldown
   * ----------------------------*/
  async startCooldown(seconds: number) {
    const startTime = Date.now();

    await this.storage.set('cooldownStart', startTime);
    await this.storage.set('cooldownDuration', seconds);

    await this.recalculateCooldown();
    this.startVisualTimer();
  }

  /** ---------------------------------
   *  Cargar cooldown previo (si existe)
   * ----------------------------------*/
  async loadCooldown() {
    const start = await this.storage.get('cooldownStart');
    const duration = await this.storage.get('cooldownDuration');

    if (start && duration) {
      await this.recalculateCooldown();
      this.startVisualTimer();
    }
  }

  /** ---------------------------------
   *  Recalcular tiempo restante real
   * ----------------------------------*/
  async recalculateCooldown() {
    const start = await this.storage.get('cooldownStart');
    const duration = await this.storage.get('cooldownDuration');

    if (!start || !duration) {
      this.remainingSeconds = 0;
      return;
    }

    const elapsed = Math.floor((Date.now() - start) / 1000);
    const remaining = duration - elapsed;

    this.remainingSeconds = remaining > 0 ? remaining : 0;

    if (this.remainingSeconds === 0) {
      await this.clearCooldown();
    }
  }

  /** ---------------------------
   *  Borrar cooldown terminado
   * ----------------------------*/
  async clearCooldown() {
    await this.storage.remove('cooldownStart');
    await this.storage.remove('cooldownDuration');
  }

  /** --------------------------------------
   *  Timer visual para la interfaz (1 segundo)
   * ----------------------------------------*/
  private startVisualTimer() {
    if (this.timer) clearInterval(this.timer);

    this.timer = setInterval(() => {
      if (this.remainingSeconds > 0) {
        this.remainingSeconds--;
      } else {
        clearInterval(this.timer);
      }
    }, 1000);
  }

  /** --------------------------------------
   *  Detectar cuando vuelve a primer plano
   * ----------------------------------------*/
  private async setupListeners() {
    if (this.platform.is('capacitor')) {
      // iOS / Android
      App.addListener('appStateChange', async ({ isActive }) => {
        if (isActive) {
          await this.recalculateCooldown();
        }
      });
    } else {
      // Web
      document.addEventListener('visibilitychange', async () => {
        if (!document.hidden) {
          await this.recalculateCooldown();
        }
      });
    }
  }
  
  isActive(): boolean {
    return this.remainingSeconds > 0;
  }
}
